module.exports = __webpack_public_path__ + "static/media/calendar-plus.45b781f4.svg";